import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import tableStyle from "../../assets/table.module.css";
import ProgressBar from "../../ui/ProgressBar/ProgressBar";
import { IFindDeviceFoundItem } from "../api/types/find-dialog.interface";
import { useFindDevice } from "../hooks/useFindDevice";
import { isSelectable } from "../lib/find-dialog";
import styles from "./FindDialog.module.css";

export const FindDialogModal = ({ show, params }: any) => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const {
    activateChecked,
    control,
    filteredFoundedOptions,
    handleCloseFindDialog,
    onSubmit,
    progress,
    selected,
    setActivateChecked,
    setFindData,
    setShowAddedChecked,
    showAddedChecked,
    setSelected,
  } = useFindDevice();

  useEffect(() => {
    setFindData(params);
  }, [params, setFindData]);

  const FindTypeTemplate = (product: IFindDeviceFoundItem) => {
    return (
      <Controller
        name={String(product.id)}
        defaultValue={product.type[0]}
        control={control}
        render={({ field }) => (
          <Dropdown
            options={product.type}
            optionLabel="caption"
            disabled={product.added}
            value={field.value}
            onChange={(e) => field.onChange(e.value)}
            className={styles.dropdown}
          />
        )}
      />
    );
  };

  return (
    <Dialog
      // dismissableMask вызывает баг с закрытием при увеличении окна браузера на двойной клик
      header="Поиск устройств"
      visible={show}
      style={{ width: 800 }}
      onHide={() => {
        handleCloseFindDialog();
      }}
    >
      <div className={styles.searchForm}>
        <div className={styles.description}>
          Статус поиска: {params.caption ? params.caption : "—"}
        </div>
        <ProgressBar
          value={progress}
          showLabel={true}
          color="primary"
          className={styles.description}
        />
        {/* <ProgressBarPrime
					mode={'determinate'} //ogorodnikov_new_progress в новой ветке
					value={progress}
					className={styles.description}
				/> */}
        <form
          className={tableStyle.tableContainer}
          style={{
            padding: 0,
          }}
          onSubmit={(data) => {
            setDisabled(true);
            onSubmit(data);
          }}
        >
          <DataTable
            scrollable
            scrollHeight="400px"
            size="small"
            showGridlines
            className={tableStyle.table}
            isDataSelectable={isSelectable}
            value={filteredFoundedOptions}
            filterLocale="ru"
            selectionMode={"checkbox"}
            emptyMessage={"Поиск не дал результатов"}
            selection={selected!}
            onSelectionChange={(e) => setSelected(e.value)}
          >
            <Column selectionMode="multiple" />
            <Column field="addr" header="Адрес" />
            <Column field="device" header="Прибор" />
            <Column field="type" header="Тип" body={FindTypeTemplate} />
          </DataTable>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderTop: "1px solid #e5e7eb",
              paddingTop: 30,
              gap: 10,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <div className={styles.checkbox}>
                <Checkbox
                  onChange={(e) => setActivateChecked(e.checked!)}
                  checked={activateChecked}
                ></Checkbox>
                <label>Активировать после добавления</label>
              </div>
              <div className={styles.checkbox}>
                <Checkbox
                  onChange={(e) => setShowAddedChecked(e.checked!)}
                  checked={showAddedChecked}
                ></Checkbox>
                <label>Показывать добавленные</label>
              </div>
            </div>
            <div>
              <Button
                disabled={!selected.length || disabled}
                label={"Добавить"}
                size="small"
                type="submit"
              />
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
};
